import * as pako from "pako"


export async function getResultsFromDuckDB (token, endpoint, filterParams,queryParams,filesParam,customer) {
  let path = "/Prod/QueryDuckDB"
  console.log("filterParams", filterParams)
  console.log("queryParams", queryParams)
  console.log("filesParam", filesParam)
  console.log("customer", customer)

  var requestParams = {
    "filters": filterParams,
    "query_info": queryParams,
    "files": filesParam,
    "customer": customer
  }

  function compressAndEncodeFilters(filters) {
    const filtersString = JSON.stringify(filters)
    const compressed = pako.gzip(filtersString)
    return btoa(String.fromCharCode.apply(null, new Uint8Array(compressed)))
  }

  requestParams.filters = compressAndEncodeFilters(requestParams.filters)
  requestParams.query_info = compressAndEncodeFilters(requestParams.query_info)
  requestParams.files = compressAndEncodeFilters(requestParams.files)
  requestParams.customer=compressAndEncodeFilters(customer)

  const options = {
    method: "POST",
    headers: {
      Authorization: token
    }
  }

  const queryString = new URLSearchParams(requestParams).toString()

  const url = `${endpoint}${path}?${queryString}`
  const request = await fetch(url, options)
  return await request.json()
}

